import { render, staticRenderFns } from "./CCMVaccineViewDialog.vue?vue&type=template&id=4e8b4de7"
import script from "./CCMVaccineViewDialog.vue?vue&type=script&lang=js"
export * from "./CCMVaccineViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports